import {AfterViewInit, Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {appConfig} from '../../../../config/config';
import {Countries} from '../../../models/countries.interface';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {PageRequest} from '../../../../shared/models/page-request.interface';
import {MatDialog} from '@angular/material/dialog';
import {EditCountryComponent} from '../edit-country/edit-country.component';
import {CreateCountryComponent} from '../create-country/create-country.component';
import {GenericDialogComponent} from '../../../../shared/components/generic-dialog/generic-dialog.component';

@Component({
  selector: 'app-countries-table',
  templateUrl: './countries-table.component.html',
  styleUrls: ['./countries-table.component.scss']
})
export class CountriesTableComponent implements AfterViewInit {

  pageSizes = appConfig.pageSizes;
  displayedColumns: string[] = ['code', 'name', 'region', 'edit'];

  @Input()
  countries!: Countries[];
  @Input()
  page!: number;
  @Input()
  pageSize = 100;
  @Input()
  totalElements!: number;

  @Output()
  loadCountries: EventEmitter<PageRequest> = new EventEmitter<PageRequest>();
  @Output()
  updateCountryStatus: EventEmitter<number> = new EventEmitter<number>();
  @Output()
  deleteCountry: EventEmitter<number> = new EventEmitter<number>();

  @ViewChild(MatPaginator)
  paginator!: MatPaginator;

  @ViewChild(MatSort)
  sort!: MatSort;

  constructor(private readonly dialog: MatDialog) { }

  ngAfterViewInit(): void {
    this.sort.sortChange.subscribe(() => this.onSortChange(this.sort.active, this.sort.direction));
  }

  onSortChange(active: string, direction: string): void {
    this.loadCountries.emit({page: 0, size: this.pageSize, sort: active, direction});
  }

  onPageChange(event: PageEvent): void {
    this.loadCountries.emit({page: event.pageIndex, size: event.pageSize, sort: this.sort.active, direction: this.sort.direction});
  }

  addCountry(): void {
    const dialogRef = this.dialog.open(CreateCountryComponent, {maxWidth: 600, width: 'inherit'} );

    dialogRef.componentInstance.createEvent.subscribe(() => {
      this.loadCountries.emit({
        page: this.paginator.pageIndex, size: this.paginator.pageSize, sort: this.sort.active, direction: this.sort.direction
      });
    });
  }

  editCountry(value: Countries): void {
    const dialogRef = this.dialog.open(EditCountryComponent, {data: value, maxWidth: 600, width: 'inherit'});

    dialogRef.componentInstance.updateEvent.subscribe(() => {
      this.loadCountries.emit({
        page: this.paginator.pageIndex, size: this.paginator.pageSize, sort: this.sort.active, direction: this.sort.direction
      });
    });
  }

  updateCountry(country: Countries, deleteCountry: boolean): void {
    const dialogRef = this.dialog.open(GenericDialogComponent,
      {
        data:
          {
            title: `${deleteCountry ? 'Delete' : (country.status === 'ACTIVE' ? 'Disable' : 'Enable')} Country`,
            text: `Are you sure you want to ${deleteCountry ? 'delete' : (country.status === 'ACTIVE' ? 'deactivate' : 'activate')} the selected item?`
          }
      });
    dialogRef.componentInstance.confirm.subscribe((confirm: boolean) => {
      if (confirm) {
        if (deleteCountry) {
          this.deleteCountry.emit(country.id);
        }
        else {
          this.updateCountryStatus.emit(country.id);
        }
      }
      dialogRef.close();
    });

    dialogRef.afterClosed().subscribe(() => {
      dialogRef.componentInstance.confirm.unsubscribe();
    });
  }

}
